import * as React from 'react'
import { clsx } from 'clsx'
import type * as Polymorphic from '@radix-ui/react-polymorphic'

import styles from './VisuallyHidden.module.css'

import type { JSX } from 'react'

type VisuallyHiddenOwnProps = {
  as?: keyof JSX.IntrinsicElements
}

type PolymorphicVisuallyHidden = Polymorphic.ForwardRefComponent<
  'span',
  VisuallyHiddenOwnProps
>

const isLegendElement = (
  element: keyof JSX.IntrinsicElements | undefined,
): boolean => element === 'legend'

/**
 * Visually hide an element but keep it accessible to assistive technology
 */
const VisuallyHidden = React.forwardRef(
  ({ as, children, className, ...otherProps }, forwardedRef) => {
    const Tag = as || 'span'
    const isLegend = isLegendElement(as)

    // Chromium gives a rendered legend its own layout box, so hide a regular descendant instead.
    return (
      <Tag
        ref={forwardedRef}
        className={clsx(isLegend ? styles.legendReset : styles.base, className)}
        {...otherProps}
      >
        {isLegend ? <span className={styles.base}>{children}</span> : children}
      </Tag>
    )
  },
) as PolymorphicVisuallyHidden

VisuallyHidden.displayName = 'VisuallyHidden'

export { VisuallyHidden }
